// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  type ForecastPlantAgg,
  type ForecastPlantAggWireFormat,
  NewForecastPlantAgg,
} from '../ForecastPlantAgg/ForecastPlantAgg';
import {
  type ForecastStatusAgg,
  type ForecastStatusAggWireFormat,
  NewForecastStatusAgg,
} from '../ForecastStatusAgg/ForecastStatusAgg';
import {
  type MonthlyForecastAgg,
  type MonthlyForecastAggWireFormat,
  NewMonthlyForecastAgg,
} from '../MonthlyForecastAgg/MonthlyForecastAgg';
import {
  NewYearlyForecastAgg,
  type YearlyForecastAgg,
  type YearlyForecastAggWireFormat,
} from '../YearlyForecastAgg/YearlyForecastAgg';

export class ForecastAgg {
  readonly byMonth: MonthlyForecastAgg[];
  readonly byYear: YearlyForecastAgg[];
  readonly byStatus: ForecastStatusAgg[];
  readonly byPlant: ForecastPlantAgg[];

  constructor(data: { [key: string]: any } = {}) {
    this.byMonth = (data.byMonth ?? []).map((byMonth: any) => NewMonthlyForecastAgg(byMonth));
    this.byYear = (data.byYear ?? []).map((byYear: any) => NewYearlyForecastAgg(byYear));
    this.byStatus = (data.byStatus ?? []).map((byStatus: any) => NewForecastStatusAgg(byStatus));
    this.byPlant = (data.byPlant ?? []).map((byPlant: any) => NewForecastPlantAgg(byPlant));
  }

  static zero(): ForecastAgg {
    const zeroValues: ExcludeMethodsDeep<ForecastAgg> = {
      byMonth: [],
      byYear: [],
      byStatus: [],
      byPlant: [],
    };
    return new ForecastAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ForecastAggWireFormat = {
  byMonth: MonthlyForecastAggWireFormat[];
  byYear: YearlyForecastAggWireFormat[];
  byStatus: ForecastStatusAggWireFormat[];
  byPlant: ForecastPlantAggWireFormat[];
};

type NewForecastAggProps = PartialDeep<ForecastAgg, { recurseIntoArrays: true }>;
export const NewForecastAgg: (props: NewForecastAggProps) => ForecastAgg = (props) =>
  new ForecastAgg(props);

type NewForecastAggFromWireFormatProps = PartialDeep<
  ForecastAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewForecastAggFromWireFormat: (
  props: NewForecastAggFromWireFormatProps,
) => ForecastAgg = (props) => new ForecastAgg(props);
